<template>
  <div class="info-card-wrapper">
    <div v-if="showShareBtn" class="share" @click="handleClickShareBtn()">分享</div>
    <div v-if="isShowShareMask" class="share-guide-mask" @click="handleClickShareMask()">
      <div class="share-guide-text">点击右上角“…”，分享给好友</div>
    </div>
    <Info-item :activityInfo="activityInfo" :userPosition="userPosition" :data="data" />
    <Footer class="footer" :footer="data.redTemplate.fnModule" :mainInfo="data" :handleCheckBoxClicked="handleCheckBoxClicked" />
  </div>
</template>

<script>
import Footer from '../../../DetailPage/components/Footer'
import InfoItem from '../InfoItem'
import { mapGetters } from 'vuex'
import { buryingPoint } from '@/utils/buryingPoint'

export default {
  components: {
    Footer,
    InfoItem
  },
  props: {
    activityInfo: {
      default: null
    },
    userPosition: {
      default: null
    },
    data: {
      require: true,
      default: null
    }
  },
  data () {
    return {
      isShowShareMask: false
    }
  },
  computed: {
    ...mapGetters(['systemInfo']),
    ...mapGetters({
      activityId: 'activityInfo/activityId'
    }),
    showShareBtn () {
      return this.systemInfo.isWx || this.systemInfo.isNfPlus
    },
    fullAddress () {
      return this.data.address.province + this.data.address.city + this.data.address.address
    }
  },
  methods: {
    handleClickShareBtn () {
      buryingPoint({ action: 19, sourceTag: 4, activityId: this.activityId, optionId:this.data.id, itemType: 2 })
      if (this.systemInfo.isWx) {
        this.handleClickShareBtnInWx()
      } else if (this.systemInfo.isNfPlus) {
        this.handleClickShareBtnInNfPlus()
      }
    },
    handleClickShareBtnInWx () {
      this.isShowShareMask = true
    },
    handleClickShareBtnInNfPlus () {
      const shareInfo = {
        title: this.data.name,
        content: this.data.introduce || this.fullAddress || document.title,
        icon: this.data.mainImage,
        url: `${window.location.href}&shopId=${this.data.id}`
      }
      window.nfplusJsbridge.nfShare(shareInfo)
    },
    handleClickShareMask () {
      this.isShowShareMask = false
    },
    handleCheckBoxClicked (data) {
      buryingPoint({...data, sourceTag: 4, optionId: this.data.id})
    },
  }
}
</script>

<style scoped="scoped" lang="scss">
.info-card-wrapper {
  position: fixed;
  bottom: 0;
  left: calc(50% - 3.55rem);
  // transform: translate(-50%, 0);
  z-index: 2000;
  width: 7.1rem;
  min-height: 3.35rem;
  box-shadow: 0 -4px 8px 0 rgba(113, 108, 98, 0.2);
  background: #ffffff;
  border-top-left-radius: 0.14rem;
  border-top-right-radius: 0.14rem;
  .share {
    width: 0.72rem;
    height: 0.52rem;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    background-image: linear-gradient(-35deg, #a1dcff 0%, #d9f5ff 100%);
    border-radius: 0 0.14rem 0 0.14rem;
    font-size: 0.24rem;
    line-height: 0.52rem;
    color: #0071ec;
    letter-spacing: 0;
    text-align: center;
  }
  .share-guide-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999999;
    .share-guide-text {
      position: absolute;
      right: 0.5rem;
      top: 0.2rem;
      width: 4.22rem;
      height: 0.95rem;
      font-size: 0.3rem;
      color: #323431;
      letter-spacing: 0;
      line-height: 1.1rem;
      text-align: center;
      background: url(../../../../assets/images/share_pop.png) no-repeat center/4.22rem;
      background-color: linear-gradient(180deg, #ffffff 23%, #edcbbe 100%);
    }
  }
  .footer {
    height: 1.37rem;
    width: 100%;
    padding: 0 0.2rem 0 0.1rem;
    display: flex;
    justify-content: space-around;
  }
}
</style>
